import { CreateSacRequest } from 'domain/usecases/sacRequest/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteCreateSacRequest implements CreateSacRequest {
  private readonly url: string;

  private readonly httpClient: HttpClient<CreateSacRequest.Model>;

  constructor(url: string, httClient: HttpClient<CreateSacRequest.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  create = async (
    params: CreateSacRequest.Params,
  ): Promise<CreateSacRequest.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      body: {
        descr: params.descr,
        docValue: params.docValue,
        email: params.email,
        name: params.name,
        phone: params.phone,
        docType: params.docType,
        topic: params.topic,
      },
      headers: params?.token
        ? {
            Authorization: `APIKEY ${params?.token}`,
          }
        : undefined,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
